import jsPDF from 'jspdf'
import type { ShoppingList } from './api'

export function exportToPDF(list: ShoppingList): void {
    const doc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' })
    const margin = 18
    let y = margin

    // Header
    doc.setFillColor(108, 99, 255)
    doc.rect(0, 0, 210, 22, 'F')
    doc.setTextColor(255, 255, 255)
    doc.setFontSize(16)
    doc.setFont('helvetica', 'bold')
    doc.text('🛒 EasyMarket', margin, 14)
    doc.setFontSize(10)
    doc.setFont('helvetica', 'normal')
    doc.text(new Date().toLocaleDateString('fr-FR'), 190, 14, { align: 'right' })

    y = 32

    // List name
    doc.setTextColor(30, 30, 60)
    doc.setFontSize(18)
    doc.setFont('helvetica', 'bold')
    doc.text(list.name, margin, y)
    y += 8

    // Meta
    doc.setFontSize(9)
    doc.setFont('helvetica', 'normal')
    doc.setTextColor(100, 100, 140)
    doc.text(`${list.nb_persons} personne(s) · ${list.duration_days} jours · ${list.meals_per_day} repas/jour`, margin, y)
    y += 12

    // Divider
    doc.setDrawColor(200, 200, 230)
    doc.line(margin, y, 210 - margin, y)
    y += 8

    // Items
    const needToBuy = list.items.filter(i => !i.owned)
    const owned = list.items.filter(i => i.owned)

    const renderSection = (title: string, items: typeof list.items, color: number[]) => {
        if (items.length === 0) return

        doc.setFontSize(11)
        doc.setFont('helvetica', 'bold')
        doc.setTextColor(color[0], color[1], color[2])
        doc.text(title, margin, y)
        y += 8

        items.forEach(item => {
            if (y > 270) {
                doc.addPage()
                y = margin
            }

            // Checkbox square
            doc.setDrawColor(180, 180, 220)
            doc.rect(margin, y - 4, 5, 5)

            doc.setFont('helvetica', 'normal')
            doc.setTextColor(40, 40, 70)
            doc.setFontSize(10)
            const qty = item.required_quantity % 1 === 0
                ? item.required_quantity.toString()
                : item.required_quantity.toFixed(1)
            const unitLabel: Record<string, string> = { cnt: 'pièce(s)', g: 'g', ml: 'ml' }
            doc.text(`${item.name}`, margin + 8, y)
            doc.setTextColor(130, 130, 170)
            doc.text(`${qty} ${unitLabel[item.unit] || item.unit}`, 170, y, { align: 'right' })
            y += 8
        })
        y += 4
    }

    renderSection('À acheter', needToBuy, [108, 99, 255])
    renderSection('✓ Déjà en stock', owned, [74, 180, 120])

    // Footer
    doc.setFontSize(8)
    doc.setTextColor(160, 160, 200)
    doc.text('Généré par EasyMarket', 105, 290, { align: 'center' })

    doc.save(`${list.name.replace(/\s+/g, '_')}.pdf`)
}

export function copyToClipboard(list: ShoppingList): string {
    const lines: string[] = [`📋 ${list.name}`, '']
    const needToBuy = list.items.filter(i => !i.owned)
    const owned = list.items.filter(i => i.owned)

    if (needToBuy.length > 0) {
        lines.push('🛒 À acheter :')
        needToBuy.forEach(item => {
            const qty = item.required_quantity % 1 === 0
                ? item.required_quantity.toString()
                : item.required_quantity.toFixed(1)
            lines.push(`  ☐ ${item.name} — ${qty} ${item.unit}`)
        })
        lines.push('')
    }

    if (owned.length > 0) {
        lines.push('✅ Déjà en stock :')
        owned.forEach(item => { lines.push(`  ✓ ${item.name}`) })
    }

    const text = lines.join('\n')
    navigator.clipboard.writeText(text)
    return text
}
